import Constant from '../../static/data/Constant';

/** ****************************************************************************
  Number validation
***************************************************************************** */
export const validateNumber = (value?: string | number): boolean => {
    if ( !/string|number/.test(typeof(value)) ) { return false; }
    const text = `${value}`.replace(/\s+/g, '');
    return /^(-)?[0-9,.]+$/.test(text);
};

/** ****************************************************************************
  Email validation
***************************************************************************** */
export const validateEmail = (value?: string): boolean => {
    const text = `${value || ''}`.replace(/\s+/g, '');
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(text);
};

/** ****************************************************************************
  Mobile validation
***************************************************************************** */
export const validateMobile = (value?: string): boolean => {
    const text = `${value || ''}`.replace(/\s+/g, '');
    return !/^0/.test(text) && validateNumber(text) && text.length === 8;
};

/** ****************************************************************************
***************************************************************************** */
export const validateLessThanOrLike = (value?: string | number, max?: string | number): boolean => {
    if (!validateNumber(value) || !validateNumber(max)) { return false; }

    value = parseFloat((`${value || ''}`).replace(/\s+/g, ''));
    max = parseFloat((`${max || ''}`).replace(/\s+/g, ''));
    return value <= max;
};

/** ****************************************************************************
***************************************************************************** */
export const validateGreatThanOrLike = (value?: string | number, min?: string | number): boolean => {
    if (!validateNumber(value) || !validateNumber(min)) { return false; }

    value = parseFloat((`${value || ''}`).replace(/\s+/g, ''));
    min = parseFloat((`${min || ''}`).replace(/\s+/g, ''));
    return value >= min;
};

/** ****************************************************************************
  code number validation
***************************************************************************** */
export const validateCodeNumber = (value?: string): boolean => {
    const text = `${value || ''}`.replace(/[\s-]+/g, '');
    return validateNumber(text) && text.length === 6;
};

/** ****************************************************************************
  peronalId validation
***************************************************************************** */
export const validatePersonalId = (value?: string) => {
    const text = `${value || ''}`.replace(/[\s-]+/g, '');
    if (!validateNumber(text) || text.length !== 11 ) { return false; }
    
    const getSum = (birthNumber: string, factors: number[]) => {
        let sum = 0;
        for (let i = 0, l = factors.length; i < l; ++i) {
            sum += parseInt(birthNumber.charAt(i), 10) * factors[i];
        }
        return sum;
    };

    let a = 11 - (getSum(text, [3, 7, 6, 1, 8, 9, 4, 5, 2]) % 11);
    if (a === 11) {
        a = 0;
    }

    let b = 11 - (getSum(text, [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]) % 11);
    if (b === 11) {
        b = 0;
    }

    return a === parseInt(text.charAt(9), 10) && b === parseInt(text.charAt(10), 10);
};

/** ****************************************************************************
  password validation
***************************************************************************** */
export const validatePassword = (value?: string) => {
    const text = `${value || ''}`;
    return text.length > 1 && !/\s/.test( text );
};

/** ****************************************************************************
 ***************************************************************************** */
export const validateRule = (value?: string | number, rule: string = ''): boolean => {
    let valid = true;
    value = `${value || ''}`.trim();
    if ( rule === Constant.validationRequired ) {
        valid = !!value;
    } else if ( rule === Constant.validationMobile ) {
        valid = validateMobile(value);
    } else if ( rule === Constant.validationPersonId ) {
        valid = validatePersonalId( value );
    } else if ( rule === Constant.validationCodeNumber ) {
        valid = validateCodeNumber( value );
    } else if ( rule === Constant.validationEmail ) {
        valid = validateEmail(value);
    } else if ( rule === Constant.validationPassword ) {
        valid = validatePassword(value);
    } 

    return valid;
};
